
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2IddZ0HpCt_458PXBHvQAg80HuiJu6UpF3Vb_XrUEK7zwMeta } from "/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93x6SS_45gXAzk31ruZUFIt0bPytCeMUIzlZWyUI3x_TF90Meta } from "/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/[...slug].vue?macro=true";
import { default as _91id_932q_832RoEndDnnrO2uMvu1mBZTFobhCpQ1ofEsOn3UsMeta } from "/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/investice/[id].vue?macro=true";
import { default as component_45stubgYbMkAuMDhObOHREs3VSgBX05j8ETSX_456KIzSIoSajkMeta } from "/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubgYbMkAuMDhObOHREs3VSgBX05j8ETSX_456KIzSIoSajk } from "/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___cs",
    path: "/",
    component: () => import("/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/index.vue")
  },
  {
    name: "slug___cs",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93x6SS_45gXAzk31ruZUFIt0bPytCeMUIzlZWyUI3x_TF90Meta || {},
    component: () => import("/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/[...slug].vue")
  },
  {
    name: "investice-id___cs",
    path: "/investice/:id()",
    meta: _91id_932q_832RoEndDnnrO2uMvu1mBZTFobhCpQ1ofEsOn3UsMeta || {},
    component: () => import("/home/runner/work/dluhopisomat-web-v2/dluhopisomat-web-v2/pages/investice/[id].vue")
  },
  {
    name: component_45stubgYbMkAuMDhObOHREs3VSgBX05j8ETSX_456KIzSIoSajkMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubgYbMkAuMDhObOHREs3VSgBX05j8ETSX_456KIzSIoSajk
  }
]